export default __webpack_public_path__ + "static/media/CentraNo2-Regular.fa648ffe.woff2";